import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { getApplicationFilters } from 'actions/application';
import get from 'lodash/get';

const isApplicationLoaded = (WrappedComponent) => {
  const HOC = (props) => {
    const dispatch = useDispatch();
    const [isApplicationReviewDataLoaded, setIsApplicationReviewDataLoaded] = useState(!!localStorage.getItem('filters'));

    useEffect(() => {
      if (!localStorage.getItem('filters') && localStorage.idToken) {
        dispatch(getApplicationFilters({
          url: 'filters/fsl-merchant-portal',
          success: (res) => {
            localStorage.setItem('filters', JSON.stringify(get(res, 'filters')));
            setIsApplicationReviewDataLoaded(true);
          },
        }));
      }
    }, [props]);

    return <WrappedComponent {...props} isApplicationReviewDataLoaded={isApplicationReviewDataLoaded} />;
  };

  HOC.propTypes = {
    location: PropTypes.object.isRequired,
  };

  return HOC;
};

export default isApplicationLoaded;



// WEBPACK FOOTER //
// ./src/components/Hoc/isApplicationFiltersLoaded.js